import http from '../http'

export default {
  getNceTimeline: () => {
    return http.get('/auction/nce_timeline')
  }
}
